import Newsletter from "@components/Newsletter/Newsletter";
import Sectioncomminity from "@components/frontpage/section_comminity";
import BaseLayout from "@layout/base-layout";
import { observer } from "mobx-react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "react-i18next";

const DataProtectionRules = observer((props) => {
  const { t } = useTranslation("common");

  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_ADDRESS}content/protection/impressum`}
        />
      </Head>
      <main className="container">
        <div className="mx-auto mt-10 w-full">
          <h1 className="m-0 text-4xl font-bold">{t("Impressum.Imprint")}</h1>
          <ul className="mt-3 text-base font-normal ">
            <li>{t("Impressum.information_according_to_§_5_tmg")}</li>
            <li> moverii GmbH</li>
            <li> {t("Impressum.Castle Street")} 4</li>
            <li> {t("Impressum.53115_Bonn")} </li>
            <li> {t("Impressum.Germany")} </li>
          </ul>
          <h2 className="m-0 text-2xl font-bold mt-10">
            {t("Impressum.Represented_by")}
          </h2>

          <p className="m-0 text-base font-normal mt-3">
            Daniel Helbig & Adrian Helbig
          </p>
          <p className="m-0 text-base font-normal ">
            {t("Impressum.e_mail_address:")} team@moverii.de
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.sales_tax_identification_number")}
          </p>
          <h2 className="m-0 text-2xl font-bold mt-10">
            {t("Impressum.online_dispute_resolution_according")}
          </h2>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.the_european_commission_provides_a_platform_for")}
          </p>
          <h2 className="m-0 text-2xl font-bold mt-10">
            {t("Impressum.liability_for_content")}
          </h2>
          <p className="m-0 text-base font-normal mt-3 ">
            {t("Impressum.as_a_service_provider_we_are_responsible_for")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.obligations_to_remove_or_block")}
          </p>
          <h2 className="m-0 text-2xl font-bold mt-10 ">
            {" "}
            {t("Impressum.liability_for_external_links")}{" "}
          </h2>
          <b></b>
          <p className="m-0 text-base font-normal mt-3 ">
            {t("Impressum.our_websites_contain_links_to_external_websites")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.however_a_permanent_control_of_the_contents")}
          </p>
          <h2 className="m-0 text-2xl font-bold mt-10">
            {t("Impressum.copyright")}{" "}
          </h2>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.the_contents_and_works_created")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.insofar_as_the_content_on_this")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.the_following_content_was_provided_by_third_parties")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.award_batch_locked_padlock")}
          </p>
          <p className="m-0 text-base font-normal mt-3">
            {t("Impressum.speak_free_icon_made_by_twitter_from_flaticon")}
          </p>
          <p className="m-0 text-base font-normal mt-3 mb-9">
            {t("Impressum.bungalow_icon_made_by_visualpharm_from_icon_icons")}
          </p>
        </div>
        <Newsletter
          image1={"/static/images/news.png"}
          image2={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Aktivurlaub_moverii.jpg"
          }
          image3={
            process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
            "cdn/statics/Newsletter-Element/Yoga-Retreats_moverii.jpg"
          }
          title={t("contact.newsletter_title")}
          description={t("contact.newsletter_description")}
          inputPlaceholder={t("contact.newsletter_placeholder")}
          buttonTitle={t("contact.newsletter_button")}
        />
        <section className={"container mx-auto mb-10"}>
          <Sectioncomminity className={"bg-orange"} mode={"white"} />
        </section>
      </main>
    </>
  );
});
DataProtectionRules.Layout = BaseLayout;
export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};
export default DataProtectionRules;
